import React from "react";
import { Row, Col } from "reactstrap";
import { customFieldsCopy } from "./copy";
import type { ResolvedFieldConfig, TaxonomyValues } from "./types";
import TaxonomyFieldRenderer from "./TaxonomyFieldRenderer";
import TaxonomyRequiredSummary from "./TaxonomyRequiredSummary";
import HistoricalTaxonomyValues from "./HistoricalTaxonomyValues";
import type { RequiredField } from "./publishFields";

type Props = {
  fields: ResolvedFieldConfig[];
  values: TaxonomyValues;
  onChange: (values: TaxonomyValues) => void;
  missing?: RequiredField[];
  loading?: boolean;
  error?: string;
  showHistorical?: boolean;
  productId?: string;
  /** The page shows the "unable to publish" summary itself (e.g. above the current step). */
  hideSummary?: boolean;
};

const ProductAttributesSection = ({
  fields,
  values,
  onChange,
  missing,
  loading,
  error,
  showHistorical,
  productId,
  hideSummary,
}: Props) => {
  const missingIds = new Set((missing || []).filter((row) => !row.focusId).map((row) => row.taxonomyId));

  return (
    <div className="formDiv hkp-product-attributes" id="hkp-product-attributes">
      <h6 className="fw-bold mb-2">{customFieldsCopy.productAttributes}</h6>
      <p className="text-muted small mb-3">{customFieldsCopy.productAttributesHelp}</p>
      {loading ? <p className="text-muted">Loading custom fields…</p> : null}
      {error ? <p className="RequiredField">{error}</p> : null}
      {missing?.length && !hideSummary ? <div className="mb-3"><TaxonomyRequiredSummary fields={missing} /></div> : null}
      {!loading && !fields.length && !error ? (
        <p className="text-muted">{customFieldsCopy.emptyMyFields}</p>
      ) : null}
      <div>
        <Row>
          {fields.map((field) => (
            <Col xs={12} md={4} key={field.taxonomyId} className="mb-3">
              <TaxonomyFieldRenderer
                field={field}
                value={values?.[field.taxonomyId]}
                invalid={missingIds.has(field.taxonomyId)}
                productId={productId}
                onChange={(id, value) => onChange({ ...values, [id]: value })}
              />
            </Col>
          ))}
        </Row>
      </div>
      {showHistorical ? <HistoricalTaxonomyValues values={values} fields={fields} /> : null}
    </div>
  );
};

export default ProductAttributesSection;
